import { render, staticRenderFns } from "./ComponentCardUser.vue?vue&type=template&id=1ce46c43&scoped=true"
import script from "./ComponentCardUser.vue?vue&type=script&lang=js"
export * from "./ComponentCardUser.vue?vue&type=script&lang=js"
import style0 from "./ComponentCardUser.vue?vue&type=style&index=0&id=1ce46c43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce46c43",
  null
  
)

export default component.exports